import { Controller } from "@hotwired/stimulus";

// Usage: data-controller="request-changes-modal"
// Handles checkbox state and submit button for request changes modal
export default class extends Controller {
  static targets = ["row", "checkbox", "submitBtn"];

  connect() {
    this._updateSubmitState();
    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener('change', this._updateSubmitState.bind(this));
    });
    // Also listen for changes on selects within rows
    this.rowTargets.forEach(row => {
      const select = row.querySelector('.select-hidden-input-value');
      if (select) {
        select.addEventListener('app-select:change', this._updateSubmitState.bind(this));
      }
    });
  }

  _updateSubmitState() {
    const checkedCheckboxes = this.checkboxTargets.filter(cb => cb.checked);

    // Must have at least one checked and all checked must have a change_type selected
    const canSubmit = checkedCheckboxes.length > 0 && checkedCheckboxes.every(checkbox => {
      const row = checkbox.closest('[data-request-changes-modal-target="row"]');
      
      if (!row) return false;
      const select = row.querySelector('.select-hidden-input-value');
      
      return select && select.value !== '';
    });
    
    this.submitBtnTarget.disabled = !canSubmit;
  }
}
